module.exports = __webpack_public_path__ + "img/red_029.1192f33b.png";